function toEmbedVideoUrl (videoLink, autoplay) {
  let youtubeId = videoLink.split('v=')[1]
  if (videoLink.indexOf('/embed/') !== -1) return videoLink
  youtubeId = youtubeId.split('&')[0]
  return `//www.youtube.com/embed/${youtubeId}?rel=0&amp;wmode=transparent&autoplay=${autoplay}`
}

function setModalVideoUrl (videoLinkElement) {
  const videoUrl = videoLinkElement.dataset.href
  const autoplay = videoLinkElement.dataset.autoplay === 'true' ? '1' : '0'
  const embedVideoUrl = toEmbedVideoUrl(videoUrl, autoplay)

  const modalRadioId = videoLinkElement.getAttribute('for')
  const modalId = document.querySelector(`#${modalRadioId}`).getAttribute('name')

  document.querySelector(`#${modalId} iframe[data-carwow-video]`).setAttribute('src', embedVideoUrl)
}

function openVideoModal (whichModal) {
  const modalElement = whichModal.getAttribute('for')
  const openRadioBtn = document.querySelector(`#${modalElement}`)
  openRadioBtn.click()
}

function handleVideoLinkClick (e) {
  if (typeof e.target.closest !== 'function') return

  const thisVideoLinkElement = e.target.closest('[data-target=video-modal-link]')

  if (thisVideoLinkElement) {
    setModalVideoUrl(thisVideoLinkElement)
  }
}

function stopVideoOnClose (e) {
  if (typeof e.target.closest !== 'function') return

  const videoModalClose = e.target.closest('[data-stop-video-on-close]')

  if (videoModalClose && videoModalClose.checked) {
    document.querySelectorAll('iframe[data-carwow-video]').forEach(video => {
      video.setAttribute('src', '')
    })
  }
}

function autoOpenVideo () {
  const openVideo = window.location.search.indexOf('video=true') !== -1
  const thisVideoLinkElement = document.querySelector('[data-target=video-modal-link]')

  if (openVideo && thisVideoLinkElement) {
    setModalVideoUrl(thisVideoLinkElement)
    openVideoModal(thisVideoLinkElement)
  }
}

function openVideoByDefault () {
  const thisVideoLinkElement = document.querySelector('[data-video-open-by-default]')

  if (thisVideoLinkElement) {
    setModalVideoUrl(thisVideoLinkElement)
    openVideoModal(thisVideoLinkElement)
  }
}

function initVideoEventListeners () {
  if (document.querySelector('[data-target=video-modal-link]')) {
    document.addEventListener('click', (e) => {
      handleVideoLinkClick(e)
    })
    document.addEventListener('change', (e) => {
      stopVideoOnClose(e)
    })
  }
}

function initVideoPlayer () {
  initVideoEventListeners()
  autoOpenVideo()
  openVideoByDefault()
}

document.addEventListener('DOMContentLoaded', initVideoPlayer)

window.Carwow = window.Carwow || {}
window.Carwow.initVideoPlayer = initVideoPlayer
